import Button from '@/components/ui/button';
import Image from '@/components/ui/images/Image';
import { useReadOrder } from '@/hooks/order/useReadOrder';
import { LineItem } from '@/infrastructure/domain/lineItem';
import { Skeleton } from 'antd';

interface Props {
  selectedLineItems: LineItem[];
  orderId?: string;
  onSelect: (products: any[]) => void;
  onNext: () => void;
  onBack: () => void;
}

export const ProductSelection: React.FC<Props> = ({
  selectedLineItems,
  orderId,
  onSelect,
  onNext,
  onBack,
}) => {
  const { data: order } = useReadOrder(orderId);
  console.log('bools', !Boolean(selectedLineItems.length));
  const toggleProduct = (lineItem: LineItem) => {
    const isSelected = selectedLineItems.find(
      selectedLineItem => selectedLineItem.id === lineItem.id,
    );
    if (isSelected) {
      onSelect(selectedLineItems.filter(li => li.id !== lineItem.id));
    } else {
      onSelect([...selectedLineItems, lineItem]);
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium">
        Please select product(s) with issues.
      </h2>

      {!order?.lineItems && <Skeleton active paragraph={{ rows: 2 }} />}

      {order?.lineItems.map(li => (
        <div
          key={li.product.name}
          className="border p-4 rounded-lg flex items-center justify-between"
        >
          <div className="flex items-center gap-4">
            <input
              type="checkbox"
              checked={selectedLineItems.includes(li)}
              onChange={() => toggleProduct(li)}
            />
            <Image
              imageSource={li.product.images?.[0]}
              className="w-12 h-12 object-cover rounded"
            />
            <div>
              <div className="font-medium">{li.product.name}</div>
              <div className="text-sm text-gray-500">
                x{li.quantity} {li.variant.unit.name}
              </div>
              <div>₱{Number(li.variant?.price) * Number(li.quantity)}</div>
            </div>
          </div>
        </div>
      ))}

      <div className="flex mt-24 gap-2 justify-end">
        <Button variant="secondary" onClick={onBack}>
          Go Back
        </Button>
        <Button
          type="primary"
          onClick={onNext}
          disabled={!Boolean(selectedLineItems.length)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};
